import { FC } from "react"
import { MUIIcon } from "../../../../../widgets"

interface Step3Props {
    image: string
    moveBack?: () => void
}

export const Step3: FC<Step3Props> = ({ image, moveBack }) => {
    return (
        <div className='card bg-light border'>
            <img
                src={image}
                alt='Cropped'
                className='card-img-top object-contain'
            />
            <div className='card-footer py-3'>
                <button
                    className='btn btn-sm btn-link link-primary'
                    onClick={() => (moveBack && moveBack())}>
                    <MUIIcon iconName='ArrowBackOutlined' /> Back
                </button>
            </div>
        </div>
    )
}
